import { render, staticRenderFns } from "./DSArrowUpIcon.vue?vue&type=template&id=2232fa98&"
import script from "./DSArrowUpIcon.vue?vue&type=script&lang=js&"
export * from "./DSArrowUpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports